import React from "react";
import "../src/header.css";

function Header() {
  return (
    <div className="header">
      <h3>Choose Your Best Movies & Web Series</h3>
    </div>
  );
}

export default Header;
